export default "__VITE_ASSET__DHPy$agf__"